export const Pages = {
  ROOT: '/',
  ABOUT: '/about',
  HOME: '/home',
  NOT_FOUND: '/not-found',
  SETTINGS: '/settings',
  GOOGLE_CONNECT: '/connexion-google',
  CONVERSATIONS: '/conversations',
  TEMPLATES: '/templates',
  TAGS: '/tags',
  ORGANIZATION: '/organization',
  LANDING: '/',
  REQUEST_RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD: '/redirect/reset-password',
  ADMIN: '/admin',
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  DATA_POLICY: '/data-policy',
  TERMS_OF_USE: '/terms-of-use',
  VERIFICATION: '/redirect/verification',
  GENERAL_SETTINGS: '/settings/general',
  SECURITY_SETTINGS: '/settings/security',
  NOTIFICATIONS_SETTINGS: '/settings/notifications',
  TRANSCRIPTION_SETTINGS: '/settings/transcription',
  SUMMARY_SETTINGS: '/settings/summary',
  PLAN_SETTINGS: '/settings/plan',
  BILLING_SETTINGS: '/settings/billing',
  BILLING_PAYMENT_METHODS: '/settings/billing/payment-methods',
  BILLING_HISTORY: '/settings/billing/history',
  INTEGRATIONS_SETTINGS: '/settings/integrations',
  // New public pages
  FEATURES: '/features',
  TEAM: '/team',
  PRICING: '/pricing',
  CONTACT: '/contact',
  DATA_PROCESSING: '/data-processing',
  FAQ: '/faq',
  DEMO: '/demo',
  AUDIO_PROCESSING: '/audio-processing',
  COOKIES: '/legal/cookies',
  CHECKOUT: '/checkout',
  NEWS: '/news',
  HELP: '/help',
  HELP_AUDIO_PROCESSING: '/help/audio-processing',
  HELP_DATA_PROCESSING: '/help/data-processing',
  HELP_FAQ: '/help/faq',
  HELP_NEWS: '/help/features',
  HELP_GENERAL_FAQ: '/help/faq/general-faq',
  HELP_AUDIO_PROCESSING_HOW_IT_WORKS: '/help/audio-processing/how-it-works',
  HELP_NEWS_ALL: '/help/features/all',
  HELP_DATA_PROCESSING_PRIVACY_POLICY: '/help/data-processing/privacy-policy',
  NEWSLETTER_UNSUBSCRIBE: '/newsletter/unsubscribe',
}
